import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';
const dateFormat = 'MM/DD/YYYY hh:mm A';

@Pipe({
    name: "toLocalDate"
})

export class ToLocalDatePipe implements PipeTransform {

    transform(value: string, format: string): string {
        let _format = format ? format : dateFormat; 
        return moment(value).format(_format);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/shared/pipes/to-local-date.pipe.ts